import DataTableStatic from 'components/organisms/data-table-static'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import CustomerRefundShippableTableColumns from './customer-refund-shippable-table-columns'


const propTypes = {
  data           : PropTypes.array,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.bool,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns: PropTypes.array
}

const defaultProps = {
  data           : [],
  rowButtonProps : {},
  hiddenColumns  : []
}

/**
 * Customer Refund Shippable Table
 * @param {array>} data - array of orders shipments objects
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */
const CustomerRefundShippableTable = ({
  data,
  rowButtonProps,
  hiddenColumns
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const { buttonText, buttonColour, isButtonDisabled, onButtonClick } = rowButtonProps
  const columns                                                       = useMemo(
    () => CustomerRefundShippableTableColumns({
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    ]
  )

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
      hiddenColumns={ hiddenColumns }
    />
  )
}

CustomerRefundShippableTable.propTypes    = propTypes
CustomerRefundShippableTable.defaultProps = defaultProps

export default CustomerRefundShippableTable